import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Alert,
  Box,
  IconButton,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import { getRoleLabel } from '../../config/routePermissions';
import { getMyPermissionGroups } from '../../config/permissionLabels';

export default function MyPermissionsDialog({ open, onClose, role, permissions }) {
  const theme = useTheme();
  const isSuperAdmin = (role || '').toLowerCase() === 'super_admin';
  const groups = isSuperAdmin ? [] : getMyPermissionGroups(permissions);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        Mis permisos
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Rol: <b>{getRoleLabel(role)}</b>
        </Typography>

        {isSuperAdmin ? (
          <Alert severity="info">
            Como SuperAdmin tenés acceso total: podés usar todas las funciones del sistema.
          </Alert>
        ) : groups.length === 0 ? (
          <Alert severity="warning">
            Tu usuario todavía no tiene permisos habilitados. Contactá a un administrador.
          </Alert>
        ) : (
          groups.map(({ group, items }) => (
            <Box key={group} sx={{ mb: 2 }}>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: theme.palette.primary.dark, mb: 0.5 }}
              >
                {group}
              </Typography>
              <List dense disablePadding>
                {items.map((label) => (
                  <ListItem key={label} disablePadding sx={{ py: 0.25 }}>
                    <ListItemIcon sx={{ minWidth: 32 }}>
                      <CheckCircleOutlineIcon fontSize="small" color="success" />
                    </ListItemIcon>
                    <ListItemText primary={label} />
                  </ListItem>
                ))}
              </List>
            </Box>
          ))
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
